import { Component, ChangeDetectorRef, OnInit, NgZone, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { onAuthUIStateChange, CognitoUserInterface, AuthState, FormFieldTypes } from '@aws-amplify/ui-components';
import  { Auth }  from  'aws-amplify' ;

import { HttpClient } from '@angular/common/http';

import jwt_decode from 'jwt-decode';
import * as AWS from 'aws-sdk'


import aws_exports from "../../../aws-exports";
import { GetusuariosService, Usuarios } from 'src/app/services/getusuarios.service';
import { Version } from '@angular/compiler';

import { AuthService, IAuthConfig } from 'src/app/core/auth';
import { ISessionData, SessionService } from 'src/app/core/auth/session.service';
import { Observable } from 'rxjs';
// import { GetversionappService, VersionApp } from 'src/app/services/getversionapp.service'; 

// import { CookiesService } from '../../services/cookies.service';
import { KeycloakService } from 'keycloak-angular';
@Component({
  selector: 'app-pagina-login-aws',
  templateUrl: './pagina-login-aws.component.html',
  styleUrls: ['./pagina-login-aws.component.scss']
})

export class PaginaLoginAwsComponent implements OnInit {
  title = 'amplify-angular-auth';
  user: CognitoUserInterface | undefined; 
  groupName : CognitoUserInterface | undefined;
  authState: AuthState;

  @Input()
  public loginUrl: string;

  @Input() 
  public logoutUrl: string;

  @Input()
  public keycloakUrl: string;

  @Input()
  public clientId: string;

  @Input()
  public realm: string;

  carer: any;

  DEBUG: boolean = true;

  urlTree : any;

  array_tab_usuarios: Usuarios[] = [];
  // array_versionapp: VersionApp[] = [];
  idPatient:string;
  patient:string; 
  launch:string;
  payload:any;

  tokenKeycloak:any;
  refreshTokenKeycloak:any;

  flagMostrarLogin: boolean = false;

  public session$: Observable<ISessionData>;
  public working$: Observable<boolean>;

  totalAngularPackages;
  urlKeycloak : string = 'https://pharaon-dev-idp.eng.it/auth/realms/ecosystem-hub/protocol/openid-connect/token';
  error;

  constructor(
    private getusuariosService: GetusuariosService, 
    // private getversionappService: GetversionappService,
    private ref: ChangeDetectorRef, 
    private router: Router, 
    private activateRoute: ActivatedRoute,
    private zone: NgZone,
    private authService: AuthService,
    // public cookies: CookiesService,
    private sessionService: SessionService,
    private keycloakService: KeycloakService,
    private http: HttpClient
    ) {

      this.working$ = this.authService.working$;
    };

  ngOnInit() {
    console.log("ngOnInit ")
    // APP MOVIL CONTROL DE VERSIONES
    //this.getVersionApp();

    // Autentificación OHC
    this.getAuthDesktop();

    // Autentificación KeyKloak
    // this.getAuthCentralPortal();

    // Autentificación AWS
    onAuthUIStateChange((nextAuthState, authData) => {
      this.zone.run(() => {
        
        // console.log(authData);
        if (nextAuthState === AuthState.SignedIn) {
          this.authState = nextAuthState;
          this.user = authData as CognitoUserInterface;
          // this.carer = this.user.username;
          this.groupName = this.user.signInUserSession.accessToken.payload["cognito:groups"]; 

          if(this.DEBUG){
            console.log("Usuario: " + this.user.username); 
            console.log("Grupo: " + this.groupName[0]);
          }

          this.ref.detectChanges();

          if(this.DEBUG){
            console.log("user successfully signed in!"); 
          }
          //Adjuntamos la politica al usuario
          this.attachedPolicy();

          // comprobamos si es master / cuidador / medico / usuario
          if (this.groupName[0] == "caregiver"){
            if(this.DEBUG){
              console.log("caregiver");
            }
            this.router.navigate(['/main-carer'], {state: {carer: this.user.username, group: this.groupName[0]}});    

          }else if (this.groupName[0] == "medical"){
            if(this.DEBUG){
              console.log("medical")
            }
            this.router.navigate(['/main-carer'], {state: {carer: this.user.username, group: this.groupName[0]}}); 

          } else if (this.groupName[0] == "master"){
            if(this.DEBUG){
              console.log("master")
            }
            this.router.navigate(['/main-master'], {state: {master: this.user.username, group: this.groupName[0]}}); 

          }else if (this.groupName[0] == "user"){
            if(this.DEBUG){
              console.log("user")
            }
            this.router.navigate(['/main-user/' + this.user.username], {state: {user: this.user.username, group: this.groupName[0]}}); 
          }

        }
      });
    
    });
  
  }
  
  // APP MOVIL - CONTROL DE VERSIONES
  // getVersionApp(){
    // Comprobar versión actual app y compararla con la versión 
    // this.asyncMethodVersionApp();
  // }
  // async asyncMethodVersionApp() {

  //   this.array_versionapp = await this.getversionappService.getVersionApp("amicare");
  //   if(this.DEBUG){
  //     console.log (this.array_versionapp);
  //   }
  //   console.log (this.array_versionapp[0].version);
  //   let version: number = Number(this.array_versionapp[0].version);

  //   console.log(version);
  //   if(version == 1.1){
  //     console.log("ACTUALIZAMOS");
  //   }
  //   // Obtenemos la version de la tabla
    
  // }

  getAuthDesktop(){

    // Recibimos el patient(privado) de indra y el Idpatient(publico)

    this.idPatient = "";

    this.activateRoute.queryParams.subscribe(params => {
      this.idPatient = params['idPatient'];
      this.launch = params['launch'];
    });

    //Decodificamos el launch
    try{
      this.payload =  jwt_decode(this.launch);
      this.flagMostrarLogin = false;
    }
    catch(Error){
      if(this.DEBUG){
        console.log("Error:" + Error);

      }
      // Mostramos login
      this.flagMostrarLogin = true;
      return null;
    }
    
    if(this.DEBUG){
      console.log(this.payload);
      console.log("AuthDesktop Public idPatient: " + this.idPatient);
      console.log("AuthDesktop Private Patient: " + this.payload.patient);
    }

    this.patient = this.payload.patient;

    
    //HARIAMOS COMPARACION CON LOS USUARIOS DE LAS BBDD como dentro del Cuidador Master que engloba a todos los usuarios
    if(this.idPatient == ""){
      //entramos normal
      this.flagMostrarLogin = true;
    }else{
      this.flagMostrarLogin = false;
      this.asyncMethodUsuarios();
    }
    
  }

    // - Nombre y apellidos: Alejandra Albagli Segovia
    // - DNI: 47405357B
    // - Fecha nacimiento: 14/12/2003
    // - Idpatient: 687923 ->Publico
    // - patient: AC1615969312256 -> Privado
    // URL PRUEBAS
    // http://localhost:4200/login-aws/?idPatient=687923&launch=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuZWVkX3ByYWN0aXRpb25lcl9iYW5uZXIiOmZhbHNlLCJuZWVkX3BhdGllbnRfYmFubmVyIjpmYWxzZSwicGF0aWVudCI6IkFDMTYxNTk2OTMxMjI1NiIsImNvbmZpZ192aWV3IjoicGMiLCJhbGciOiJIUzI1NiJ9.11GnTE6bMcbX2XXTH7_gOEa3pui3uFFTx_lMs_ZDGUo&iss=https:%2F%2Fproyvalhnwl1.indra.es%2Fehrserver%2Ffhir
    // https://master.d3bvci0sdxtp32.amplifyapp.com/?idPatient=687923&launch=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuZWVkX3ByYWN0aXRpb25lcl9iYW5uZXIiOmZhbHNlLCJuZWVkX3BhdGllbnRfYmFubmVyIjpmYWxzZSwicGF0aWVudCI6IkFDMTYxNTk2OTMxMjI1NiIsImNvbmZpZ192aWV3IjoicGMiLCJhbGciOiJIUzI1NiJ9.11GnTE6bMcbX2XXTH7_gOEa3pui3uFFTx_lMs_ZDGUo&iss=https:%2F%2Fproyvalhnwl1.indra.es%2Fehrserver%2Ffhir
  
    //PACIENTE PRUEBA DOS PHARAON
    // http://localhost:4200/login-aws/?idPatient=100003&launch=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuZWVkX3ByYWN0aXRpb25lcl9iYW5uZXIiOmZhbHNlLCJuZWVkX3BhdGllbnRfYmFubmVyIjpmYWxzZSwicGF0aWVudCI6IkFDMTY2NTAzNTMwNjQ3MyIsImNvbmZpZ192aWV3IjoicGMiLCJhbGciOiJIUzI1NiJ9.cOpwbO-Xh5TqMp3904GHZFXn1o8OKYMrzS0ixa93_0o&iss=https:%2F%2Fproyvalhnwl1.indra.es%2Fehrserver%2Ffhir
    async asyncMethodUsuarios() {
   
    this.array_tab_usuarios = await this.getusuariosService.getUsuarios("master");  
    if(this.DEBUG){
      console.log (this.array_tab_usuarios);
    }
    
    for(let i=0; i < this.array_tab_usuarios.length; i++ ){
      // if(this.idPatient == this.array_tab_usuarios[i].userid && this.patient == this.array_tab_usuarios[i].patient){
        if(this.idPatient == this.array_tab_usuarios[i].idPatient && this.patient == this.array_tab_usuarios[i].patient){
        this.router.navigate(['/main-user/' + this.idPatient], {state: {arrayUser: this.array_tab_usuarios[i], group: "carer", entorno: "OHC"}}); 
      }    
    }
    this.flagMostrarLogin = true; 
  }

  getAuthCentralPortal(){

    // this.session$ = this.sessionService.session$;

    // const config: IAuthConfig = {
    //   clientId: "dash-button",
    //   realm: "ecosystem-hub",
    //   url: "https://pharaon-dev-idp.eng.it",
    //   // loginUrl: "https://pharaon-dev-idp.eng.it/auth/realms/ecosystem-hub/protocol/openid-connect",
    //   // logoutUrl: "https://pharaon-dev-idp.eng.it/auth/realms/ecosystem-hub/protocol/openid-connect/logout"
    // }


    // this.authService.initialize(config);
    // console.log ("1. this.getAuthCentralPortal");
    // console.log("1 Estamos logados: " + this.authService.isAuthenticated());
    // console.log("1 session$: " + this.session$[0]);
    // console.log ("2. this.getAuthCentralPortal");

    // console.log(this.getCookie('Pharaon_Portal_session'));

    setTimeout(() => {
      console.log("this.totalAngularPackages");
      const headers = {'Access-Control-Request-Headers': 'Access-Control-Allow-Origin' }
      this.http.get<any>(this.urlKeycloak, { headers }).subscribe(data => {
        this.totalAngularPackages = data.total;
        console.log(this.totalAngularPackages);
     },error => this.error = error);

      // let cookie_Pharaon_Portal_session = this.getCookie('Pharaon_Portal_session');
      // let cookie_Pharaon_Portal_sessionJSON = JSON.parse( decodeURIComponent(cookie_Pharaon_Portal_session));
      // if(this.DEBUG){
      //   console.log(cookie_Pharaon_Portal_sessionJSON);
      // }

      // this.tokenKeycloak = jwt_decode(cookie_Pharaon_Portal_sessionJSON.token_info.token);
      // if(this.DEBUG){
      //   console.log(this.tokenKeycloak);
      // }
      // this.refreshTokenKeycloak = jwt_decode(cookie_Pharaon_Portal_sessionJSON.token_info.refreshToken);
      // if(this.DEBUG){
      //   console.log(this.refreshTokenKeycloak);
      //   console.log ("tokenKeycloak[0].sid " + this.tokenKeycloak.sid + "refreshTokenKeycloak[0].sid " + this.refreshTokenKeycloak.sid)
      // }
      // if (this.tokenKeycloak.sid == this.refreshTokenKeycloak.sid){
      //   // console.log ("DENTRO")
      //   // Entramos al usuario de pruebas creado para el Portal Central
      //   this.obtenerUsuarioKeycocak();      
        
      // }
      
    },
    1000);
  } 

//   autenti(){
//     this.authService.isAuthenticated();
    
//   }

//  async signOut(){
//   console.log("salir de la sesion de keycloak")
//     this.keycloakService.clearToken();
//     this.keycloakService.logout();  
//   }

  async obtenerUsuarioKeycocak(){
    if(this.DEBUG){
      console.log("obtenerUsuarios")
    }
      this.array_tab_usuarios = await this.getusuariosService.getUsuarios("52364667S"); 
    // console.log(this.array_tab_usuarios)
    // cogemos el PACIENTE PRUEBA DOS con el entorno "LogKeyCloak" para saber que estamos logueados por este método
    this.router.navigate(['/main-user/' + this.array_tab_usuarios[0].nombre + this.array_tab_usuarios[0].apellidos], {state: {arrayUser: this.array_tab_usuarios[0], group: "carer", entorno: "LogKeyCloak"}}); 

  }

  public getCookie(name: string) {
    console.log("getCookie");
    let ca: Array<string> = document.cookie.split(';');
    console.log(document.cookie);
    decodeURIComponent
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    console.log(cookieName )
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        
        return c.substring(cookieName.length, c.length); 
      }
    }
    return '';
  }



  attachedPolicy(){

    this.zone.run(() => {

    Auth.currentCredentials().then((info) => {
      // const cognitoIdentityId = info.data.IdentityId;
      // console.log("IdentityId: "+info.identityId);

      AWS.config.region = aws_exports.aws_project_region;
      
      // AWS.config.credentials = aws_exports.poolId;
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: aws_exports.aws_cognito_identity_pool_id
        // IdentityId : info.identityId
      });
      // console.log(AWS.config.credentials);
      const IoT = new AWS.Iot();
      // console.log(IoT.config);
      IoT.attachPrincipalPolicy({
        policyName: 'PharaOn_policy',
        principal: info.identityId
      }, (err, res) => {
        if (err) console.error(err);
           // Connect to AWS IoT MQTT
          });
    });

    });
  }

  ngOnDestroy() {
    return onAuthUIStateChange;
  }


}